/* rc-continuum.js — Feed Continuum landing page.
   No dependencies. Everything is namespaced under the section root. */

(function () {
  'use strict';

  var root = document.querySelector('[data-rc-root]');
  if (!root) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  function readJSON(sel, fallback) {
    var el = document.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var VARIANTS = readJSON('[data-rc-variants]', { default: null, items: [] });
  var PROMISES = readJSON('[data-rc-promises]', []);

  var state = {
    variantId: VARIANTS.default,
    added: false,
    card: -1,   // -1 so the first onScroll() lights the current card's dot on load
    sound: sessionStorage.getItem('rc:sound') === 'on',
    saved: false
  };

  function variantById(id) {
    for (var i = 0; i < VARIANTS.items.length; i++) {
      if (String(VARIANTS.items[i].id) === String(id)) return VARIANTS.items[i];
    }
    return null;
  }

  /* ── Variant selection ──────────────────────────────── */

  function setVariant(id, opts) {
    var v = variantById(id);
    if (!v) return;
    state.variantId = v.id;

    $$('[data-rc-variant]').forEach(function (btn) {
      btn.setAttribute('aria-checked', String(btn.dataset.rcVariant) === String(v.id) ? 'true' : 'false');
    });
    $$('[data-rc-pill-variant]').forEach(function (el) { el.textContent = v.title; });
    $$('[data-rc-pill-price]').forEach(function (el) { el.textContent = v.price; });

    // Sheet primary button carries the price as a "· $price" suffix.
    var addPrice = $('[data-rc-add-price]');
    if (addPrice) addPrice.textContent = ' · ' + v.price;

    // Each size carries its own fine print (50ml includes a free sample, 12ml
    // does not). Card 4, the pill meta, and the sheet fine all track it.
    $$('[data-rc-fineprint]').forEach(function (el) { el.textContent = v.fineprint || ''; });

    if (!(opts && opts.silent)) {
      state.added = false;
      syncCtaLabels();
    }
  }

  function syncCtaLabels() {
    var cta = $('[data-rc-cta-label]');
    var add = $('[data-rc-add-label]');
    var addPrice = $('[data-rc-add-price]');
    if (cta) cta.textContent = state.added ? 'View bag' : (cta.dataset.rcInitial || cta.textContent);
    if (add) add.textContent = state.added ? 'View bag' : 'Add to bag';
    // The "· $price" suffix belongs to the "Add to bag" state only.
    if (addPrice) addPrice.hidden = state.added;
  }

  var ctaLabelEl = $('[data-rc-cta-label]');
  if (ctaLabelEl) ctaLabelEl.dataset.rcInitial = ctaLabelEl.textContent;

  $$('[data-rc-variant]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.hasAttribute('disabled')) return;
      setVariant(btn.dataset.rcVariant);
    });
  });

  setVariant(state.variantId, { silent: true });

  /* ── Message match (?rc_ad=) ────────────────────────── */

  (function messageMatch() {
    var adId = new URLSearchParams(window.location.search).get('rc_ad');
    if (!adId || !PROMISES.length) return;

    var match = null;
    for (var i = 0; i < PROMISES.length; i++) {
      var ids = String(PROMISES[i].ad_ids || '').split(',').map(function (s) { return s.trim(); });
      if (ids.indexOf(String(adId).trim()) !== -1) { match = PROMISES[i]; break; }
    }
    if (!match) return;

    var swaps = [
      ['[data-rc-source]', match.source],
      ['[data-rc-kicker]', match.kicker],
      ['[data-rc-hook]', match.hook],
      ['[data-rc-proof-label]', match.proof_label],
      ['[data-rc-offer-label]', match.offer_label]
    ];
    swaps.forEach(function (pair) {
      var el = $(pair[0]);
      if (el && pair[1]) el.textContent = pair[1];
    });

    $$('[data-rc-dot]').forEach(function (d) { d.hidden = false; });

    if (match.variant_id && variantById(match.variant_id)) {
      setVariant(match.variant_id, { silent: true });
    }
  }());

  /* ── Video manager ──────────────────────────────────── */

  var videos = $$('[data-rc-video]');

  function applySound() {
    videos.forEach(function (v) { v.muted = !state.sound; });
    var btn = $('[data-rc-sound]');
    if (btn) {
      // aria-pressed drives which SVG (muted/on) shows via CSS; the label
      // describes the ACTION, which is intentionally the inverse of the icon.
      btn.setAttribute('aria-pressed', String(state.sound));
      btn.setAttribute('aria-label', state.sound ? 'Turn sound off' : 'Turn sound on');
    }
  }

  function loadAndPlay(v) {
    if (!v.dataset.src) return;
    if (!v.src) v.src = v.dataset.src;
    v.muted = !state.sound;
    var p = v.play();
    if (p && p.catch) {
      p.catch(function () {
        /* Autoplay refused (usually because sound is on). Fall back to muted. */
        v.muted = true;
        v.play().catch(function () {});
      });
    }
    v.setAttribute('data-rc-playing', '');
  }

  if (!reduced && videos.length && 'IntersectionObserver' in window) {
    var vObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          loadAndPlay(v);
        } else {
          v.pause();
          v.removeAttribute('data-rc-playing');
        }
      });
    }, { threshold: 0.6 });
    videos.forEach(function (v) { vObserver.observe(v); });
  }

  var soundBtn = $('[data-rc-sound]');
  var soundHint = $('[data-rc-sound-hint]');

  function dismissSoundHint() {
    if (!soundHint || soundHint.hidden) return;
    soundHint.classList.add('rc-sound-hint--out');
    // Under reduced motion the fade transition is disabled, so hide right away.
    setTimeout(function () { soundHint.hidden = true; }, reduced ? 0 : 650);
  }

  if (soundBtn) {
    soundBtn.addEventListener('click', function () {
      state.sound = !state.sound;
      sessionStorage.setItem('rc:sound', state.sound ? 'on' : 'off');
      applySound();
      dismissSoundHint();
    });
  }
  applySound();

  // One-time "Tap for sound" affordance — muted autoplay is otherwise invisible.
  // Only when no sound preference is set this session; fades after ~4s (or just
  // disappears under reduced motion, since the CSS transition is stripped there).
  if (soundHint && sessionStorage.getItem('rc:sound') === null) {
    soundHint.hidden = false;
    setTimeout(dismissSoundHint, 4000);
  }

  /* ── Save toggle (UI only) ──────────────────────────── */

  var saveBtn = $('[data-rc-save]');
  if (saveBtn) {
    saveBtn.addEventListener('click', function () {
      state.saved = !state.saved;
      saveBtn.setAttribute('aria-pressed', String(state.saved));
      var icon = $('[data-rc-save-icon]');
      if (icon) icon.textContent = state.saved ? '♥' : '♡';
    });
  }

  /* ── Scroll: chapter dots + IG→shop chrome ──────────── */

  var feed = $('[data-rc-feed]');
  var cards = $$('.rc-card');

  // Build the chapter dots from the actual number of cards, so the rail stays
  // correct as cards are added/removed — never a hardcoded count.
  var dotsNav = $('[data-rc-dots]');
  if (dotsNav && !dotsNav.children.length) {
    cards.forEach(function (c, i) {
      var d = document.createElement('span');
      d.className = 'rc-dots__dot';
      d.setAttribute('data-rc-dotnav', String(i));
      dotsNav.appendChild(d);
    });
  }
  var dots = $$('[data-rc-dotnav]');

  function onScroll() {
    var i = Math.round(feed.scrollTop / Math.max(feed.clientHeight, 1));
    if (i !== state.card) {
      state.card = i;
      dots.forEach(function (d, n) {
        if (n === i) d.setAttribute('data-rc-active', '');
        else d.removeAttribute('data-rc-active');
      });
    }
    if (feed.scrollTop > 60) root.setAttribute('data-rc-shopmode', '');
    else root.removeAttribute('data-rc-shopmode');
  }

  if (feed) {
    feed.addEventListener('scroll', function () {
      window.requestAnimationFrame(onScroll);
    }, { passive: true });
    onScroll();
  }

  /* ── Jump to the reviews card (card 1 rail star button) ──
     A manual rAF tween of scrollTop (cubic ease). scrollTo({behavior:'smooth'})
     no-ops in some overflow containers, so it's not used. scroll-snap-type is
     mandatory on the feed and would snap mid-tween, so it's turned off for the
     duration and restored on completion. An in-flight tween is cancelled on
     re-tap; the jump is instant under reduced motion. */

  var jumpRAF = null;
  function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function cancelJump() {
    if (jumpRAF) { window.cancelAnimationFrame(jumpRAF); jumpRAF = null; feed.style.scrollSnapType = ''; }
  }

  function jumpTo(cardEl) {
    if (!feed || !cardEl) return;
    cancelJump();
    var target = cardEl.offsetTop;                 // card's snap position within the feed
    if (reduced) { feed.scrollTop = target; onScroll(); return; }
    var start = feed.scrollTop;
    var dist = target - start;
    if (!dist) return;
    var t0 = null, duration = 480;
    feed.style.scrollSnapType = 'none';            // stop snap from fighting the tween
    function step(now) {
      if (t0 === null) t0 = now;
      var p = Math.min((now - t0) / duration, 1);
      feed.scrollTop = start + dist * easeInOutCubic(p);
      if (p < 1) { jumpRAF = window.requestAnimationFrame(step); }
      else { jumpRAF = null; feed.style.scrollSnapType = ''; onScroll(); }
    }
    jumpRAF = window.requestAnimationFrame(step);
  }

  var reviewsCard = $('.rc-card--reviews');
  $$('[data-rc-jump-reviews]').forEach(function (b) {
    b.addEventListener('click', function () { jumpTo(reviewsCard); });
  });

  /* ── Reveal on scroll ───────────────────────────────── */

  if (!reduced && 'IntersectionObserver' in window) {
    var rObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-rc-in', '');
        rObserver.unobserve(entry.target);
      });
    }, { threshold: 0.55 });
    $$('[data-rc-reveal]').forEach(function (el) { rObserver.observe(el); });
  } else {
    $$('[data-rc-reveal]').forEach(function (el) { el.setAttribute('data-rc-in', ''); });
  }

  /* ── Buy sheet ──────────────────────────────────────── */

  var sheet = $('[data-rc-sheet]');
  var panel = $('.rc-sheet__panel');
  var lastFocus = null;
  var feedScrollTop = 0;

  function lockFeed() {
    if (!feed) return;
    feedScrollTop = feed.scrollTop;      // remember where the feed is
    feed.style.overflow = 'hidden';      // freeze the background scroll
  }
  function unlockFeed() {
    if (!feed) return;
    feed.style.overflow = '';
    feed.scrollTop = feedScrollTop;      // restore exactly — no snap re-jump
  }

  // "View bag" — open the theme's own cart drawer, not the /cart page.
  // mini-cart.js's fetchCart() re-renders the current cart and opens #cart-drawer
  // (via toggleCart) WITHOUT adding anything — the correct path here. Falls back
  // to the cart page only if that global isn't present, so the button never
  // dead-ends.
  function viewBag() {
    if (typeof window.fetchCart === 'function') {
      window.fetchCart();
    } else {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }
  }

  function openSheet() {
    if (state.added) { viewBag(); return; }
    lastFocus = document.activeElement;
    sheet.hidden = false;
    lockFeed();
    var first = $('.rc-sheet__close') || $('[data-rc-add-to-cart]');
    if (first) first.focus();
  }
  function closeSheet() {
    if (sheet.hidden) return;
    if (panel) { panel.style.transition = ''; panel.style.transform = ''; }
    sheet.hidden = true;
    unlockFeed();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  $$('[data-rc-open-sheet]').forEach(function (b) { b.addEventListener('click', openSheet); });
  $$('[data-rc-close-sheet]').forEach(function (b) { b.addEventListener('click', closeSheet); });

  // Tap anywhere outside the panel dismisses. Bound to the wrapper and tested by
  // containment, so it doesn't depend on the backdrop's exact geometry.
  if (sheet && panel) {
    sheet.addEventListener('click', function (e) {
      if (!panel.contains(e.target)) closeSheet();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
  });

  /* Swipe-down to dismiss: drag the handle or header, follow the finger, and
     dismiss past ~25% of the panel height or on a fast downward flick; otherwise
     spring back. Skipped under reduced motion — open/close only, no drag-follow. */
  if (!reduced && sheet && panel) {
    var dragging = false, startY = 0, curDy = 0, startT = 0;

    function onDown(e) {
      if (e.button != null && e.button > 0) return;      // primary pointer only
      dragging = true;
      startY = e.clientY;
      curDy = 0;
      startT = e.timeStamp || Date.now();
      panel.style.transition = 'none';
    }
    function onMove(e) {
      if (!dragging) return;
      var dy = e.clientY - startY;
      if (dy < 0) dy = 0;                                 // downward only
      curDy = dy;
      panel.style.transform = 'translateY(' + dy + 'px)';
    }
    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      var h = panel.getBoundingClientRect().height || 1;
      var dt = Math.max((e.timeStamp || Date.now()) - startT, 1);
      var velocity = curDy / dt;                          // px per ms
      panel.style.transition = 'transform 240ms cubic-bezier(.2,.8,.2,1)';
      if (curDy > h * 0.25 || velocity > 0.6) {
        panel.style.transform = 'translateY(100%)';
        var done = function () { panel.removeEventListener('transitionend', done); closeSheet(); };
        panel.addEventListener('transitionend', done);
        setTimeout(done, 320);                            // fallback if no transitionend
      } else {
        panel.style.transform = 'translateY(0)';          // spring back
      }
    }

    [$('.rc-sheet__grab'), $('.rc-sheet__head')].forEach(function (z) {
      if (z) z.addEventListener('pointerdown', onDown);
    });
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
  }

  /* ── Cart ───────────────────────────────────────────────
     Routes through the theme's own cart, not a standalone flow.
     Mirrors the PDP (assets/product-form.js) and the theme's
     abz bundle sections: POST /cart/add.js, then hand off to the
     theme's cart wiring —
       • if the upsell <top-drawer> is present, open it (its own
         close() calls fetchCart(), which re-renders + opens the
         #cart-drawer and updates the cart-counter bubble);
       • otherwise dispatch 'theme:product:add', which mini-cart.js
         binds to fetchCart() — the same event the abz sections use.
     Both paths reuse the store's real drawer, count bubble,
     free-gift / order-protection and cart analytics. No second
     cart implementation. */

  function addToCart(variantId, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add failed');
      return r.json();
    }).then(function (data) {
      var upsell = document.querySelector('top-drawer');
      if (upsell && typeof upsell.open === 'function') {
        upsell.open();
      } else {
        document.dispatchEvent(new CustomEvent('theme:product:add'));
      }
      return data;
    });
  }

  var addBtn = $('[data-rc-add-to-cart]');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (state.added) { viewBag(); return; }
      addBtn.setAttribute('disabled', '');
      addToCart(state.variantId, 1)
        .then(function () {
          state.added = true;
          syncCtaLabels();
          closeSheet();
        })
        .catch(function () {
          var label = $('[data-rc-add-label]');
          if (label) label.textContent = 'Could not add — try again';
        })
        .then(function () { addBtn.removeAttribute('disabled'); });
    });
  }
}());
